import Cookies from 'universal-cookie';

const cookies = new Cookies();

const localKey = "_vtoa";

const getLocalAccessToken = () => {
  const local = cookies.get(localKey);
  let user = {};
  if (local) {
    user = local;
  }
  return user?.access_token;
};

const getLocalRefreshToken = () => {
  const local = cookies.get(localKey);
  let user = {};
  if (local) {
    user = local;
  }
  return user?.refresh_token;
};

const updateLocalAccessToken = (token) => {
  const local = cookies.get(localKey);
  let user = {};
  if (local) {
    user = local;
  }
  user.access_token = token;
  cookies.set(localKey, JSON.stringify(user), { host: process.env.HOSTNAME, path: '/', secure: false });
};

const updateLocalRefreshToken = (token) => {
  const local = cookies.get(localKey);
  let user = {};
  if (local) {
    user = local;
  }
  user.refresh_token = token;
  cookies.set(localKey, JSON.stringify(user), { host: process.env.HOSTNAME, path: '/', secure: false });
};

const getUser = () => {
  const local = cookies.get(localKey);
  let user = {};
  if (local) {
    user = local;
  }
  return user;
};

const removeUser = () => {
  cookies.remove(localKey);
};

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  updateLocalRefreshToken,
  getUser,
  removeUser,
};

export default TokenService;
